import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import monthSelectPlugin from "flatpickr/dist/esm/plugins/monthSelect/index.js"
import weekSelectPlugin from "flatpickr/dist/esm/plugins/weekSelect/weekSelect.js"

export default class extends Controller {
  static values = {
    altInput: Boolean,
    enableTime: Boolean,
    inline: Boolean,
    altFormat: String,
    dateFormat: String,
    minDate: String,
    mode: String,
    rangeSeparator: String,
    defaultHour: Number,
    defaultMinute: Number,
    monthSelect: Boolean,
    weekSelect: Boolean,
    weekEndingLabel: String,
    submitOnChange: Boolean
  }

  connect() {
    const options = {}

    if (this.hasAltInputValue) options.altInput = this.altInputValue
    if (this.hasEnableTimeValue) options.enableTime = this.enableTimeValue
    if (this.hasAltFormatValue) options.altFormat = this.altFormatValue
    if (this.hasDateFormatValue) options.dateFormat = this.dateFormatValue
    if (this.hasMinDateValue) options.minDate = this.minDateValue
    if (this.hasInlineValue) options.inline = this.inlineValue
    if (this.hasModeValue) options.mode = this.modeValue
    if (this.hasRangeSeparatorValue) options.locale = { rangeSeparator: this.rangeSeparatorValue }
    if (this.hasDefaultHourValue) options.defaultHour = this.defaultHourValue
    if (this.hasDefaultMinuteValue) options.defaultMinute = this.defaultMinuteValue

    if (this.hasMonthSelectValue && this.monthSelectValue) {
      options.plugins = [monthSelectPlugin({
        dateFormat: options.dateFormat || "Y-m",
        altFormat: options.altFormat || "F Y"
      })]
    }

    if (this.hasWeekSelectValue && this.weekSelectValue) {
      options.plugins = [weekSelectPlugin()]

      const altFormat = options.altFormat
      const weekEndingLabel = this.hasWeekEndingLabelValue ? this.weekEndingLabelValue : "Week"
      options.formatDate = (date, format) => {
        const pad = (n) => String(n).padStart(2, "0")

        if (format === altFormat) {
          const endOfWeek = new Date(date)
          endOfWeek.setDate(endOfWeek.getDate() + (6 - endOfWeek.getDay()))
          return `${weekEndingLabel} Ending ${pad(endOfWeek.getMonth() + 1)}/${pad(endOfWeek.getDate())}/${endOfWeek.getFullYear()}`
        }

        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
      }
    }

    if (this.hasSubmitOnChangeValue && this.submitOnChangeValue) {
      options.onChange = () => {
        if (this.element.form) this.element.form.requestSubmit()
      }
    }

    this.picker = flatpickr(this.element, options)

    this.destroyPicker = this.destroyPicker.bind(this)
    document.addEventListener("turbo:before-cache", this.destroyPicker)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.destroyPicker)
    this.destroyPicker()
  }

  destroyPicker() {
    if (this.picker) {
      this.picker.destroy()
      this.picker = null
    }
  }
}
